/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccountMappingListRequest,
  AccountMappingListResponse,
  AccountMappingReplaceRequest,
  CacheStatus,
  MapString,
  OauthLocation,
  PaginatedResultSlackUserInfo,
  SlackConnection,
  SlackConnectionRemovalResponse,
  SlackConnectionV2,
  SlackUserListResponse,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "slack";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Initiate Slack OAuth
   *
   * @tags oauth
   * @name InitiateSlackOAuth
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/oauth/slack/initiate
   * @secure
   */
  initiateSlackOAuth = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      OauthLocation,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/oauth/slack/initiate`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for initiateSlackOAuth */
  initiateSlackOAuthPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/oauth/slack/initiate`);

  /**
   * @description Complete Slack OAuth
   *
   * @tags oauth
   * @name CompleteSlackOAuth
   * @request GET:/v1/public/oauth/callback
   */
  completeSlackOAuth = (
    query: {
      /** @minLength 1 */
      code?: string;
      /** @minLength 1 */
      error?: string;
      /** @minLength 1 */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      any,
      | void
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/public/oauth/callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Returns string containing request path for completeSlackOAuth */
  completeSlackOAuthPathGetter = (query: {
    /** @minLength 1 */
    code?: string;
    /** @minLength 1 */
    error?: string;
    /** @minLength 1 */
    state: string;
  }) => this.getServicePath(`/v1/public/oauth/callback`, query);

  /**
   * @description Get slack connection
   *
   * @tags connections
   * @name GetSlackConnection
   * @request GET:/v1/tenant/{tenantId}/connections/slack
   * @secure
   */
  getSlackConnection = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SlackConnection,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/connections/slack`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSlackConnection */
  getSlackConnectionPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/connections/slack`);

  /**
   * @description Delete slack connection
   *
   * @tags connections
   * @name DeleteSlackConnection
   * @request DELETE:/v1/tenant/{tenantId}/connections/slack
   * @secure
   */
  deleteSlackConnection = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SlackConnectionRemovalResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/connections/slack`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteSlackConnection */
  deleteSlackConnectionPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/connections/slack`);

  /**
   * @description Get slack connection
   *
   * @tags connections
   * @name GetSlackConnectionStatus
   * @request GET:/v1/tenant/{tenantId}/connectionStatus
   * @secure
   */
  getSlackConnectionStatus = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SlackConnectionV2,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/connectionStatus`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSlackConnectionStatus */
  getSlackConnectionStatusPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/connectionStatus`);

  /**
   * @description List account mappings
   *
   * @tags account-mappings
   * @name ListAccountMappings
   * @request POST:/v1/tenant/{tenantId}/account-mappings/list
   * @secure
   */
  listAccountMappings = (tenantId: string, data: AccountMappingListRequest, params: RequestParams = {}) =>
    this.request<
      AccountMappingListResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/account-mappings/list`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAccountMappings */
  listAccountMappingsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/account-mappings/list`);

  /**
   * @description Replace account mappings
   *
   * @tags account-mappings
   * @name ReplaceAccountMappings
   * @request POST:/v1/tenant/{tenantId}/account-mappings/replace
   * @secure
   */
  replaceAccountMappings = (tenantId: string, data: AccountMappingReplaceRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/account-mappings/replace`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceAccountMappings */
  replaceAccountMappingsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/account-mappings/replace`);

  /**
   * @description List slack users
   *
   * @tags slack-users, deprecated
   * @name ListSlackUsers
   * @request GET:/v1/tenant/{tenantId}/slack-users/list
   * @deprecated
   * @secure
   */
  listSlackUsers = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SlackUserListResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/slack-users/list`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listSlackUsers */
  listSlackUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/slack-users/list`);

  /**
   * @description List slack users paginated
   *
   * @tags slack-users
   * @name ListSlackUsersPaginated
   * @request GET:/v1/tenant/{tenantId}/slack-users/list/paginated
   * @secure
   */
  listSlackUsersPaginated = (
    tenantId: string,
    query?: {
      /** search string in name or email */
      search?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSlackUserInfo,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/slack-users/list/paginated`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listSlackUsersPaginated */
  listSlackUsersPaginatedPathGetter = (
    tenantId: string,
    query?: {
      /** search string in name or email */
      search?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/slack-users/list/paginated`, query);

  /**
   * @description Show slack users cache status
   *
   * @name CacheStatus
   * @request GET:/v1/tenant/{tenantId}/slack-users/cache
   */
  cacheStatus = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      CacheStatus,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/slack-users/cache`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for cacheStatus */
  cacheStatusPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/slack-users/cache`);

  /**
   * @description Load all slack users into cache
   *
   * @name PreloadCache
   * @request POST:/v1/tenant/{tenantId}/slack-users/cache
   */
  preloadCache = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      CacheStatus,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/slack-users/cache`,
      method: "POST",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for preloadCache */
  preloadCachePathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/slack-users/cache`);

  /**
   * @description Clear slack users caches
   *
   * @name ClearCaches
   * @request DELETE:/v1/tenant/{tenantId}/slack-users/cache
   */
  clearCaches = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/slack-users/cache`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Returns string containing request path for clearCaches */
  clearCachesPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/slack-users/cache`);
}
